import { Component, Injector, OnInit } from '@angular/core';
import { UserGroupType } from 'tnx-admin-service/authorization/constants';
import { UserGroupHasUserService, UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import { ComponentContextService, DataFormBase, EntityPickerColumn, EntityPickerControlSchema, EventData, FormSchemaBase, Operator, ResponseResult, TextControlSchema } from 'tnx-shared';

@Component({
    selector: 'user-group-contain-user',
    templateUrl: './user-group-contain-user.component.html',
    styleUrls: ['./user-group-contain-user.component.scss'],
    providers: [ComponentContextService]
})
export class UserGroupContainUserComponent extends DataFormBase implements OnInit {

    constructor(
        protected _injector: Injector,
        private _userGroupService: UserGroupService,
        private _userGroupHasUserService: UserGroupHasUserService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
        this.setting.baseService = this._userGroupService;
        this.setting.schema = <FormSchemaBase[]>[
            new TextControlSchema({
                field: 'userName',
                label: 'Tài khoản',
                disabled: true
            }),
            new TextControlSchema({
                field: 'fullNameNew',
                label: 'Họ và tên',
                disabled: true
            }),
            new EntityPickerControlSchema({
                field: 'idUserGroups',
                baseService: this._userGroupService,
                multiple: true,
                mdWidth: 12,
                title: 'Chọn nhóm',
                displayField: 'fullNameNew',
                valueField: 'id',
                useDefaultFilterInList: true,
                defaultFilters: [
                    this.newFilter('type', Operator.equal, UserGroupType.Group)
                ],
                columns: [
                    new EntityPickerColumn({
                        label: 'Tên',
                        code: 'name',
                        dataType: 'string',
                        operator: Operator.contain,
                        fullTextSearch: true
                    }),
                    new EntityPickerColumn({
                        label: 'Mô tả',
                        code: 'description',
                        dataType: 'string',
                        operator: Operator.contain,
                        fullTextSearch: true
                    }),
                ]
            })
        ]
    }

    async onFormInitialized(formEvent: EventData) {
        this._userGroupHasUserService.getAll(
            [
                this.newFilter('idUser', Operator.equal, this.model.data.userId),
            ],
            'idUserGroup'
        ).then(rs => {
            if (rs.success && rs.data && rs.data.length) {
                formEvent.model.idUserGroups = rs.data.map(x => x.idUserGroup);
            }
        });
    }

    async onFormEvent(evt) {
        console.log(evt);
    }

    getPromiseActionInsert(): Promise<ResponseResult> {
        return this._userGroupService.updateUserGroupForUser(
            this.model.data.userId,
            this.model.data.idUserGroups);
    }


}
